import { theme } from '@acorns/grove'
import { AcornsIcon } from '@acorns/icons'
import { Button, Drawer } from '@acorns/web-components'
import styled from 'styled-components'

export const InputContainer = styled.div`
  border-radius: 0px 0px ${theme.borderRadius.medium}
    ${theme.borderRadius.medium};
  padding: 20px;
  background-color: ${theme.colors.primaryWhite};
  flex-shrink: 0;
  border-bottom: 2px solid ${theme.colors.primaryIvory};
  @media screen and (max-width: ${theme.dimensions.breakpointsSmall}px) {
    border-radius: 0px;
  }
`

export const InnerInputContainer = styled.div`
  border-radius: ${theme.borderRadius.extraLarge};
  min-height: 52px;
  display: flex;
  align-items: flex-end;
  background-color: ${theme.colors.primaryIvoryLight};
`

export const ChatInput = styled.textarea`
  width: 100%;
  position: relative;
  padding: 14px 0px 14px 20px;
  border: none;
  left: 0;
  line-height: 22px;
  border-radius: ${theme.borderRadius.large};
  background: none;
  font-size: 14px;
  font-family: inherit;
  resize: none;
  overflow-y: hidden;
  max-height: 120px;
  &:focus {
    outline-width: 0;
    outline: none;
  }
  ::placeholder {
    color: ${theme.colors.primaryStone};
    font-weight: 400;
  }
`

export const ChatContainer = styled.div<{ isMinimized: boolean }>`
  width: ${(props) => (props.isMinimized ? '335px' : '375px')};
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  height: ${(props) => (props.isMinimized ? '60px' : '550px')};
  display: flex;
  flex-direction: column;
  border: 2px solid ${theme.colors.primaryIvory};
  border-bottom: none;
  border-radius: 20px;
  box-shadow: 0px 3px 20px 10px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  @media screen and (max-width: ${theme.dimensions.breakpointsSmall}px) {
    position: fixed;
    bottom: ${(props) => (props.isMinimized ? `${72 + 15}px` : 'inherit')};
    right: ${(props) => (props.isMinimized ? '20px' : '0')};
    width: ${(props) => (props.isMinimized ? '335px' : '100%')};
    height: ${(props) => (props.isMinimized ? 'initial' : '100%')};
    border: ${(props) =>
      props.isMinimized ? `2px solid ${theme.colors.primaryIvory}` : 'none'};
    border-radius: ${(props) => (props.isMinimized ? '20px' : '0')};
  }
`

export const ContentContainer = styled.div<{ isMinimized: boolean }>`
  background-color: ${theme.colors.primaryWhite};
  display: ${(props) => (props.isMinimized ? 'none' : 'flex')};
  flex-direction: column-reverse;
  flex: 1;
  min-height: 0;
  overflow: auto;
  position: relative;
  .Toastify__toast-body {
    min-width: auto;
  }
  @media screen and (max-width: ${theme.dimensions.breakpointsSmall}px) {
    .Toastify__toast-body {
      margin-right: 10px;
    }
  }
`

export const BasicContainer = styled(ContentContainer)`
  display: block;
  height: 100%;
  padding-top: calc(50% - 30px);
`

export const SubmitButton = styled.button<{ disabled: boolean }>`
  background-color: ${theme.colors.primarySlate};
  border-radius: 50%;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  ${(props) => props.disabled && 'opacity: 0.2;'}
  margin-right: 10px;
  width: 32px;
  height: 32px;
  min-height: 32px;
  margin-bottom: 10px;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(270deg);
`

export const SendIcon = styled(AcornsIcon)`
  background: transparent;
  width: 16px;
  height: 16px;

  path {
    &[fill] {
      fill: ${theme.colors.primaryWhite};
    }
  }
`

export const StartConversationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: 100%;
  margin-top: 114px;
  font-size: 22px;
  font-weight: ${theme.fontWeight.demiBold};
  line-height: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 370px;
  overflow-x: hidden;

  @media screen and (max-width: ${theme.dimensions.breakpointsSmall}px) {
    margin-top: 50%;
    width: 100%;
  }
`

export const AcornContainer = styled.div<{ hasSearchTerms: boolean }>`
  background-color: ${theme.colors.primaryGreen};
  border-radius: 50%;
  width: ${(props) => (props.hasSearchTerms ? '45px' : '60px')};
  height: ${(props) => (props.hasSearchTerms ? '45px' : '60px')};
  min-height: ${(props) => (props.hasSearchTerms ? '45px' : '60px')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
`

export const StyledAcorn = styled(AcornsIcon)`
  path {
    fill: ${theme.colors.primaryWhite};
  }
`

export const TextContainer = styled.span<{ hasSearchTerms: boolean }>`
  width: 100%;
  max-width: ${(props) => (props.hasSearchTerms ? '260px' : '295px')};
  font-size: ${(props) => (props.hasSearchTerms ? '18px' : 'inherit')};
  line-height: ${(props) => (props.hasSearchTerms ? '26px' : 'inherit')};
  margin-left: ${(props) => (props.hasSearchTerms ? '10px' : '0')};
  text-align: ${(props) => (props.hasSearchTerms ? 'left' : 'center')};
`

export const ToastContainer = styled.div`
  > div > div {
    position: absolute;
    top: 0;
    left: 0;
  }

  > div > div > div {
    position: absolute;
    transform: none !important;
    width: calc(100% - 10px);
    top: -5px !important;
    left: 5px;
  }
`

export const GreetingContainer = styled.div<{ hasSearchTerms: boolean }>`
  position: ${(props) => (props.hasSearchTerms ? 'absolute' : 'relative')};
  top: ${(props) => (props.hasSearchTerms ? '20px' : 'inherit')};
  left: ${(props) => (props.hasSearchTerms ? '20px' : 'inherit')};
  display: flex;
  flex-direction: ${(props) => (props.hasSearchTerms ? 'row' : 'column')};
  justify-content: ${(props) =>
    props.hasSearchTerms ? 'flex-start' : 'center'};
  align-items: ${(props) => (props.hasSearchTerms ? 'flex-start' : 'center')};
`

// z-index: 503 - get above chat interface z-index
export const StyledDrawer = styled(Drawer)`
  z-index: 503;
  width: 375px;

  > div {
    width: 100%;
  }

  @media screen and (max-width: ${theme.dimensions.breakpointsSmall}px) {
    width: 100%;
  }
`

export const StyledButton = styled(Button)<{ isInvisible?: boolean }>`
  visibility: ${({ isInvisible }) => (isInvisible ? 'hidden' : 'visible')};
  margin-top: 20px;
  width: 100%;
`
